import styled, { keyframes } from 'styled-components/macro';
import { colour } from '@notonthehighstreet/toolkit/utils';

const FadeOut = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0 },
});

export const TickContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 10%;
  background-color: #3ab4d9;
  position: relative;
  box-sizing: border-box;
  padding: 10px 5px;
  margin: 40px auto;
  opacity: 0;
  animation: ${FadeOut} 1.5s linear;
`;

export const TickPath = styled.path({
  fill: colour('pampas'),
  stroke: colour('pampas'),
  strokeMiterLimit: '10',
  strokeWidth: '4px',
});
